// Must load before React touches the DOM — shields React's commits from
// extensions (click-to-call dialers, translators) that reparent its nodes.
import './utils/domExtensionGuard';
import React from 'react';
import ReactDOM from 'react-dom/client';
// Tahoma is the site typeface (--app-font-family in index.css) and needs no
// webfont. Inter is still loaded because it's one of the options in the Font
// Preview bar — without these the picker's "Inter" row would silently fall back
// to a system face on any machine that doesn't have Inter installed, making the
// comparison a lie. Drop these once the typeface decision is locked in.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { initErrorReporter, setErrorReporterUser } from './services/errorReporter';
import { msalInstance } from './services/authConfig';
import { scan } from 'react-scan';

// Ship window.onerror/unhandledrejection to system_logs before anything renders
initErrorReporter();
setErrorReporterUser(() => msalInstance.getActiveAccount()?.username);

// Enable react-scan only in local development
if (import.meta.env.DEV) {
  scan({
    enabled: true,
    log: false, // Disable console logging
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Trigger deployment to update API key - Thu Oct 23 13:05:14 CDT 2025
